import type { StripeApi } from "../../api/StripeApi";
import type { StripeCancelReaderRequest } from "../../generated/dto/StripeCancelReaderRequest";
import type { StripeConfiguration } from "../../generated/dto/StripeConfiguration";
import type { StripeReader } from "../../generated/dto/StripeReader";
import type { StripeReaderSimulationResult } from "../../generated/dto/StripeReaderSimulationResult";
import type { StripeSimulateReaderRequest } from "../../generated/dto/StripeSimulateReaderRequest";

export class StripeFrontendService {
  constructor(private readonly api: StripeApi) {}
  async cancelReaderStaff(request: StripeCancelReaderRequest): Promise<void> {
    return this.api.cancelReaderStaff(request)
  }
  async configurationPublic(): Promise<StripeConfiguration> {
    return this.api.configurationPublic()
  }
  async readersStaff(): Promise<Array<StripeReader>> {
    return this.api.readersStaff()
  }
  async simulateReaderStaff(request: StripeSimulateReaderRequest): Promise<StripeReaderSimulationResult> {
    return this.api.simulateReaderStaff(request)
  }
}
